import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  ArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
  BooleanField,
  EditButton,
} from "react-admin";
import Filter from "./filter";
import BulkActions from "./bulk-actions/";
import Pagination from "../pagination";
import { ImageField } from "../fields";
import { VideoLink } from "../fieldvideolink";

export default (props) => {
  return (
    <List
      title="Artworks"
      filters={<Filter permissions={props.permissions} />}
      sort={{ field: "id", order: "DESC" }}
      pagination={<Pagination />}
      perPage={100}
      bulkActionButtons={<BulkActions permissions={props.permissions} />}
      {...props}
    >
      <Datagrid>
        <EditButton />
        <TextField source="id" />
        <TextField source="status" />
        <ReferenceField source="provider_id" reference="users" link={false}>
          <FunctionField
            render={(record) => `${record.first_name} ${record.last_name}`}
          />
        </ReferenceField>
        <ReferenceField source="artist_id" reference="artists" link={false}>
          <FunctionField
            render={(record) => `${record.first_name} ${record.last_name}`}
          />
        </ReferenceField>
        <TextField source="name" />
        <ImageField source="preview_img_url" label="Preview URL" width="60" />
        <ReferenceField source="art_type_id" reference="art-types" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <ArrayField source="categories">
          <SingleFieldList>
            <ReferenceField reference="categories" source="id" link={false}>
              <ChipField source="name" />
            </ReferenceField>
          </SingleFieldList>
        </ArrayField>
        {(props.permissions === "MASTER_ADMIN" ||
          props.permissions === "ADMIN") && <BooleanField source="wall" />}
        {(props.permissions === "MASTER_ADMIN" ||
          props.permissions === "ADMIN") && (
          <BooleanField source="staff_pick" />
        )}
        {(props.permissions === "MASTER_ADMIN" ||
          props.permissions === "ADMIN") && <TextField source="price_tier" />}
        {(props.permissions === "MASTER_ADMIN" ||
          props.permissions === "ADMIN") && <TextField source="license_type" />}
        <TextField source="updatedAt" label="Last Modified" />
        {(props.permissions === "MASTER_ADMIN" ||
          props.permissions === "ADMIN") && (
          <VideoLink source="url" label="Video Link" />
        )}
      </Datagrid>
    </List>
  );
};
